var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@naturehouse/design-system/components/protons/icon/Icon.macro.njk"] = require( "@naturehouse/design-system/components/protons/icon/Icon.macro.njk" );




var shim = require("/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["design-system/v3/components/molecules/list/List.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "items"))) {
var t_1;
t_1 = env.getFilter("merge").call(context, env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "classes"),[]),["nh-list","nh-list--" + "" + env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "orientation"),"vertical")]);
frame.set("classes", t_1, true);
if(frame.topLevel) {
context.setVariable("classes", t_1);
}
if(frame.topLevel) {
context.addExport("classes", t_1);
}
output += "<ul\n        class=\"";
output += runtime.suppressValue(env.getFilter("join").call(context, runtime.contextOrFrameLookup(context, frame, "classes")," "), env.opts.autoescape);
output += "\"";
frame = frame.push();
var t_4 = env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "data"));
if(t_4) {t_4 = runtime.fromIterator(t_4);
var t_2;
if(runtime.isArray(t_4)) {
var t_3 = t_4.length;
for(t_2=0; t_2 < t_4.length; t_2++) {
var t_5 = t_4[t_2][0];
frame.set("[object Object]", t_4[t_2][0]);
var t_6 = t_4[t_2][1];
frame.set("[object Object]", t_4[t_2][1]);
frame.set("loop.index", t_2 + 1);
frame.set("loop.index0", t_2);
frame.set("loop.revindex", t_3 - t_2);
frame.set("loop.revindex0", t_3 - t_2 - 1);
frame.set("loop.first", t_2 === 0);
frame.set("loop.last", t_2 === t_3 - 1);
frame.set("loop.length", t_3);
output += " ";
output += runtime.suppressValue(t_5, env.opts.autoescape);
if(t_6) {
output += "=\"";
output += runtime.suppressValue(t_6, env.opts.autoescape);
output += "\"";
;
}
;
}
} else {
t_2 = -1;
var t_3 = runtime.keys(t_4).length;
for(var t_7 in t_4) {
t_2++;
var t_8 = t_4[t_7];
frame.set("name", t_7);
frame.set("value", t_8);
frame.set("loop.index", t_2 + 1);
frame.set("loop.index0", t_2);
frame.set("loop.revindex", t_3 - t_2);
frame.set("loop.revindex0", t_3 - t_2 - 1);
frame.set("loop.first", t_2 === 0);
frame.set("loop.last", t_2 === t_3 - 1);
frame.set("loop.length", t_3);
output += " ";
output += runtime.suppressValue(t_7, env.opts.autoescape);
if(t_8) {
output += "=\"";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "\"";
;
}
;
}
}
}
frame = frame.pop();
output += "\n    >\n        ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("item", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n            ";
var t_13;
t_13 = env.getFilter("merge").call(context, env.getFilter("default").call(context, runtime.memberLookup((t_12),"classes"),[]),["nh-list__item"]);
frame.set("itemClasses", t_13, true);
if(frame.topLevel) {
context.setVariable("itemClasses", t_13);
}
if(frame.topLevel) {
context.addExport("itemClasses", t_13);
}
output += "\n            <li class=\"";
output += runtime.suppressValue(env.getFilter("join").call(context, runtime.contextOrFrameLookup(context, frame, "itemClasses")," "), env.opts.autoescape);
output += "\">\n                ";
if(env.getTest("defined").call(context, runtime.memberLookup((t_12),"icon")) === true && env.getTest("defined").call(context, runtime.memberLookup((runtime.memberLookup((t_12),"icon")),"name")) === true) {
output += "\n                    ";
env.getTemplate("@naturehouse/design-system/components/protons/icon/Icon.macro.njk", false, "design-system/v3/components/molecules/list/List.html.njk", false, function(t_15,t_14) {
if(t_15) { cb(t_15); return; }
t_14.getExported(function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
frame.set("iconTemplate", t_14);
output += "\n                    ";
output += runtime.suppressValue((lineno = 11, colno = 42, runtime.callWrap(runtime.memberLookup((t_14),"render"), "iconTemplate[\"render\"]", context, [{"name": runtime.memberLookup((runtime.memberLookup((t_12),"icon")),"name"),"size": env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((t_12),"icon")),"size"),"1"),"classes": env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((t_12),"icon")),"classes"),[]),"custom": env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((t_12),"icon")),"custom"),false)}])), env.opts.autoescape);
output += "\n                ";
})});
}
output += "\n\n                ";
if(env.getTest("defined").call(context, runtime.memberLookup((t_12),"label")) === true) {
output += "\n                    <span>";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_12),"label")), env.opts.autoescape);
output += "</span>\n                ";
;
}
output += "\n\n                ";
if(env.getTest("defined").call(context, runtime.memberLookup((t_12),"info")) === true) {
output += "\n                    <button\n                        class=\"nh-info-tip\"\n                        data-role=\"info-dialog\"\n                        data-label=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"info")),"ariaLabel"), env.opts.autoescape);
output += "\"\n                        data-info-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"info")),"id"), env.opts.autoescape);
output += "\"\n                    >\n                        ";
env.getTemplate("@naturehouse/design-system/components/protons/icon/Icon.macro.njk", false, "design-system/v3/components/molecules/list/List.html.njk", false, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
t_17.getExported(function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
frame.set("iconTemplate", t_17);
output += "\n                        ";
output += runtime.suppressValue((lineno = 31, colno = 46, runtime.callWrap(runtime.memberLookup((t_17),"render"), "iconTemplate[\"render\"]", context, [{"name": "info","size": 0.75}])), env.opts.autoescape);
output += "\n                    </button>\n                ";
})});
}
output += "\n            </li>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </ul>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["design-system/v3/components/molecules/list/List.html.njk"] , dependencies)